import React, { createContext, Dispatch, useContext, useReducer } from "react";
import { RecentActivities, RecentInsights } from "./WasteManagementContext";
import {
  AgriChartData,
  AgriChartDataResp,
  BinOverviewReportCard,
  GetInfraDetectionTrendData,
  InfraChartData,
  InfraGraphData,
  InfraReportData,
  ProcessedAgriChartData,
  ProcessedDetectionChartData,
  ProcessedRetailFreshnesstData,
  ProcessedRetailShelftData,
  RetailFreshnessData,
  RetailShelfData,
  TotalDeviceCount,
} from "../Models/Models";
import { SnapViewInfo } from "../Models/Models";

export interface RetailType {
  hasChartData: boolean;
  groupId: string;
  type: string;
  siteCode: string;
  infraGraphData: InfraGraphData[];
  infraGraphDuration: string;
  agriGrowthChartData: InfraChartData[];
  AgriChartData: AgriChartData[];
  agriGrowthGraphData: InfraChartData[];
  RetailFreshnessData: RetailFreshnessData[];
  ProcessedRetailShelftData: ProcessedRetailShelftData[];
  ProcessedRetailFreshnesstData: ProcessedRetailFreshnesstData[];
  infraChartDuration: string;
  tooltipChange: number;
  tooltipValue: number;
  infrachartStartIndex: number;
  TotalDeviceCount: TotalDeviceCount[];
  snapViewInfo: SnapViewInfo[];
  fromDate: string;
  dates: string[];
  modalOpen: boolean;
  currentDateIndex: number;
  infraDetectionDuration: string;
  label: string;
  selectedRetailLables: string;
  RetailLabels: string[];
  loader: boolean;
  agriReportData: InfraReportData[];
  totalWasteMoniterValue: number;
  totalWasteValueChanges: string;
  totalWasteValueColor: string;
  averageFillWastelabel: number;
  avgWasteValueChanges: string;
  avgWasteValueColor: string;
  pageNo: number;
  pageSize: number;
  totalElements: number;
}

const initialState: RetailType = {
  hasChartData: false,
  groupId: "",
  type: "",
  siteCode: "",
  loader: false,
  infraGraphData: [] as InfraGraphData[],
  infraGraphDuration: "Last 6 months",
  agriGrowthChartData: [] as InfraChartData[],
  AgriChartData: [] as AgriChartData[],
  agriGrowthGraphData: [] as InfraChartData[],
  infraChartDuration: "months",
  infraDetectionDuration: "Monthly",
  tooltipChange: 0,
  tooltipValue: 0,
  infrachartStartIndex: 0,
  TotalDeviceCount: [] as TotalDeviceCount[],
  RetailFreshnessData: [] as RetailFreshnessData[],
  ProcessedRetailShelftData: [] as ProcessedRetailShelftData[],
  ProcessedRetailFreshnesstData: [] as ProcessedRetailFreshnesstData[],
  snapViewInfo: [],
  fromDate: "",
  dates: [],
  modalOpen: false,
  label: "",
  currentDateIndex: 0,
  selectedRetailLables: "",
  RetailLabels: [],
  agriReportData: [] as InfraReportData[],
  totalWasteMoniterValue: 0,
  totalWasteValueChanges: "",
  totalWasteValueColor: "",
  averageFillWastelabel: 0,
  avgWasteValueChanges: "",
  avgWasteValueColor: "",
  pageNo: 0,
  pageSize: 10,
  totalElements: 0,
};

type ActionType =
  | {
      field: keyof RetailType;
      type: "SET_FIELD";
      value:
        | string
        | string[]
        | boolean
        | number
        | HTMLElement
        | BinOverviewReportCard[]
        | RecentActivities[]
        | RecentInsights[]
        | InfraGraphData[]
        | InfraChartData[]
        | TotalDeviceCount[]
        | RetailShelfData[]
        | ProcessedRetailShelftData[]
        | RetailFreshnessData[]
        | ProcessedRetailFreshnesstData[]
        | AgriChartData[]
        | SnapViewInfo[]
        | undefined
        | null;
    }
  | {
      type: "BULK_UPDATE";
      value: Partial<RetailType>;
    }
  | {
      type: "RESET";
    }
  | {
      type: "SET_HAS_CHART_DATA";
      value: boolean;
    };

const reducer = (state: RetailType, action: ActionType): RetailType => {
  switch (action.type) {
    case "SET_FIELD":
      return { ...state, [action.field]: action.value };
    case "BULK_UPDATE":
      return { ...state, ...action.value };
    case "RESET":
      return { ...initialState };
    default:
      return state;
  }
};

const RetailProvider = createContext<{
  RetailState: RetailType;
  dispatchRetail: Dispatch<ActionType>;
}>({
  RetailState: initialState,
  dispatchRetail: () => null,
});

type ContextProviderProps = {
  children: React.ReactNode;
};

const RetailContext = ({ children }: ContextProviderProps) => {
  const [RetailState, dispatchRetail] = useReducer(reducer, initialState);

  return (
    <RetailProvider.Provider value={{ RetailState, dispatchRetail }}>
      {children}
    </RetailProvider.Provider>
  );
};

const useRetail = () => {
  return useContext(RetailProvider);
};

export { RetailContext, useRetail };
